import { render, staticRenderFns } from "./ModalEditChannelLanguages.vue?vue&type=template&id=4ae1efca"
import script from "./ModalEditChannelLanguages.vue?vue&type=script&lang=js"
export * from "./ModalEditChannelLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports